import React from 'react';
import { Input, Button, Spin } from 'antd';
import { Controller } from 'react-hook-form';
import { StyledForm, FormRow, Field } from './styled';
import { useSettingForm } from './hooks';
import { SettingTypes } from '.';
import LabelHoc from './LabelHoc';
import { validateWholeNumber, validateNumber } from './ValidationUtils';

const RangeMessage = 'Value should be >=0';

function NewAppVersion({ data = {} }) {
  const { control, handleSubmit, errors, mutation, onSubmit, readOnly } = useSettingForm({
    data,
    type: SettingTypes.appVersionPerf,
  });

  const hasError = Object.values(errors).length > 0;

  return (
    <StyledForm onSubmit={handleSubmit(onSubmit)}>
      <Spin tip="Saving..." spinning={mutation.isLoading}>
        <FormRow>
          <LabelHoc text="Impacted Unique Devices" err={errors.UniqueDevices} />
          <Field>
            <Controller
              render={({ field }) => (
                <Input addonBefore=">=" defaultValue="20" {...field} readOnly={readOnly} />
              )} /* tslint:disable-line */
              name="UniqueDevices"
              control={control}
              rules={{
                required: 'Impacted Unique Devices is required',
                min: { value: 0, message: RangeMessage },
                validate: validateWholeNumber,
              }}
            />
          </Field>
        </FormRow>

        <FormRow>
          <LabelHoc text="Traffic on App Version" err={errors.SpiStreamsPct} />
          <Field>
            <Controller
              render={({ field }) => (
                <Input
                  addonBefore=">="
                  defaultValue="5"
                  addonAfter="%"
                  {...field}
                  readOnly={readOnly}
                />
              )} /* tslint:disable-line */
              name="SpiStreamsPct"
              control={control}
              rules={{
                required: 'Traffic is required',
                min: { value: 0, message: RangeMessage },
                validate: validateNumber,
              }}
            />
          </Field>
        </FormRow>

        <FormRow>
          <span />
          <Button htmlType="submit" disabled={readOnly || mutation.isLoading || hasError}>
            Save
          </Button>
        </FormRow>
      </Spin>
    </StyledForm>
  );
}

export default NewAppVersion;
